module.exports = __webpack_public_path__ + "img/dataAccuracy.9451b2fa.png";